export const useStyles = () => ({
	V3: {
		marginLeft: '-15px',
		marginRight: '-15px',
	},
	bgBlue: {
		background: '#5058C8',
		color: '#ffffff',
	},
	bannerContainer: {
		paddingTop: 22,
		paddingBottom: 22,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'space-between',
		maxWidth: 1150,
	},
	bannerTitle: {
		fontSize: 20,
		fontWeight:  700,
		paddingBottom: 10,
	},
	bannerContent: {
		fontSize: 14,
		fontWeight:  400,
	},
	bannerBtnContainer: {
		display: 'flex',
		aligntems: 'center',
		justifyContent: 'center',
		marginLeft: 20,
	},
	bannerBtn: {
		display: 'inline-block',
		color: '#ffffff',
		padding: '20px 30px 20px 30px',
		fontSize: 15,
		minWidth: 150,
		background: '#FF8F00',
		textAlign: 'center',
		fontWeight: 700,
		lineHeight: '17px',
		borderRadius: 30,
		textDecoration: 'none',
		whiteSpace: 'nowrap',
	},
	'@media (max-width: 800px)': {
		bannerContainer: {
			display: 'block',
			textAlign: 'center',
		},
		bannerBtnContainer: {
			marginTop: 20,
			marginLeft: 0,
		}
	}
});